import { unityColorTokens } from '../../unityTokens';
import { ChronosphereColor } from './types';

export const unityBlue: ChronosphereColor = {
  50: unityColorTokens['--color-blue-50'],
  100: unityColorTokens['--color-blue-100'],
  150: unityColorTokens['--color-blue-200'],
  200: unityColorTokens['--color-blue-300'],
  300: unityColorTokens['--color-blue-400'],
  400: unityColorTokens['--color-blue-500'],
  500: unityColorTokens['--color-blue-600'],
  600: unityColorTokens['--color-blue-700'],
  700: unityColorTokens['--color-blue-800'],
  800: unityColorTokens['--color-blue-900'],
  850: unityColorTokens['--color-blue-950'],
  900: unityColorTokens['--color-blue-1000'],
  950: unityColorTokens['--color-blue-1000'],
};

export const blue: ChronosphereColor = {
  50: '#EDF4FD',
  100: '#D1E4FA',
  150: '#B0D0F6',
  200: '#95C0F4',
  300: '#7AB0F1',
  400: '#5E9FEE',
  500: '#438FEB',
  600: '#2A75CF',
  700: '#1F5FAD',
  800: '#184A88',
  850: '#113662',
  900: '#09213D',
  950: '#020C17',
};
